<template>
  <vs-popup class="template-editor-popup" :active.sync="popupActive" title="Template Editor">
    <div class="template-editor">
      <div class="template-editor-form">
        <div class="form-group">
          <label for="template-name">Name</label>
          <vs-input id="template-name"
                    v-model="templateName"
                    placeholder="Enter template name"
                    class="w-full" />
        </div>

        <div class="form-group">
          <label for="template-description">Description</label>
          <vs-textarea id="template-description"
                       v-model="templateDescription"
                       placeholder="Enter template description" />
        </div>

        <div class="form-group">
          <vs-button @click="saveTemplate" color="primary" type="filled">
            Save Template
          </vs-button>
        </div>
      </div>

      <div class="template-editor-preview">
        <div class="preview-label">Preview</div>
        <vs-card class="preview-container" :class="{ active: isActive }">
          <img v-if="imagePreview"
               :src="imagePreview"
               alt="Template Preview"
               class="preview-image" />
          <div v-else class="no-preview">
            No preview available
          </div>
        </vs-card>
      </div>
    </div>
  </vs-popup>
</template>

<script>
  import TCVelikClient from '@/TCVelikClient/TCVelikClient.js';

  export default {
    props: {
      isActive: {
        type: Boolean,
        default: false
      },
      imagePreview: {
        type: String,
        default: null
      },
      active: {
        type: Boolean,
        default: false
      },
      rawHtml: {
          type: String,
          default: null
      }
    },
    data() {
      return {
        templateName: '',
        templateDescription: '',
        popupActive: this.active
      };
    },
    watch: {
      active(val) {
        this.popupActive = val;
      },
      popupActive(val) {
        this.$emit('update:active', val);
      }
    },
    methods: {
      async saveTemplate() {
        var instance = this
        try {
          const mutation = `
          mutation CreateStepTemplate($name: String!, $description: String!, $rawHTML: String!) {
            createStepTemplate(name: $name, description: $description, rawHTML: $rawHTML) {
            }
          }
        `;

          const variables = {
            name: this.templateName,
            description: this.templateDescription,
            rawHTML: this.rawHtml
          };

          const req ={
            query:mutation,
            variables:variables
          }

          TCVelikClient.PostRelative("/api/graphql", req, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            }
          }).then(function (response) {
            if (response && response.data && response.data.data) {
              instance.$vs.notify({
                title: 'Saved step template',
                color: 'success'
              });
              instance.$emit("step-template-saved")
            }
          }).catch(function (err) {
          console.error('Could not copy step template: ', err);
        });

        } catch (error) {
          console.error('Error saving template:', error);
          this.$vs.notify({
            title: 'Error',
            text: 'An error occurred while saving',
            color: 'danger'
          });
          this.$emit('save-error', error);
        }
      }
    }
  };
</script>

<style scoped>
  .template-editor {
    display: flex;
    gap: 20px;
    padding: 20px;
    min-height: 400px;
  }

  .template-editor-form {
    flex: 1;
    max-width: 50%;
  }

  .form-group {
    margin-bottom: 20px;
  }

    .form-group label {
      display: block;
      margin-bottom: 8px;
      font-weight: 600;
      color: #333;
    }

  .w-full {
    width: 100%;
  }

  .template-editor-preview {
    flex: 1;
    max-width: 50%;
  }

  .preview-label {
    font-weight: 600;
    margin-bottom: 10px;
    color: #333;
  }

  .preview-container {
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f9f9;
  }

    .preview-container.active {
      border: 2px solid rgba(var(--vs-primary), 1);
      background-color: #f0f7ff;
    }

  .preview-image {
    max-width: 100%;
    max-height: 400px;
    object-fit: contain;
    border-radius: 4px;
  }

  .no-preview {
    color: #999;
    font-style: italic;
  }
</style>

<style>
  .template-editor-popup .vs-popup {
    width: 90%;
    max-width: 1200px;
  }
</style>
